'use strict';

/* eslint-disable */
/**
 * Array.prototype.includes()
 * @description The includes() method determines whether an array includes a certain value among its entries, returning true or false as appropriate.
 * @since v2.13.0
 * @param {*} valueToFind - The value to search for.
 * @param {Number} [fromIndex=0] - The position in this array at which to begin searching for `valueToFind`; the first character to be searched is found at `fromIndex` for positive values of `fromIndex`, or at `array.length + fromIndex` for negative values of `fromIndex` (using the absolute value of `fromIndex` as the number of characters from the end of the string at which to start the search). Defaults to 0.
 * @returns {Boolean} A `Boolean` which is `true` if the value `valueToFind` is found within the array (or the part of the array indicated by the index `fromIndex`, if specified). Values of zero are all considered to be equal regardless of sign (that is, -0 is considered to be equal to both 0 and +0), but `false` is not considered to be the same as 0.
 * @module polyfills/array/includes.js
 * @see <a href="https://github.com/lukeed/arr/tree/master/packages/includes">@arr/includes</a> GitHub
 * @example
 *   [1, 2, 3].includes(2);
 *   // expected output: true
 *
 *   var pets = ['cat', 'dog', 'bat'];
 *
 *   pets.includes('cat');
 *   // expected output: true
 *
 *   pets.includes('at');
 *   // expected output: false
 **/
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function value(valueToFind, fromIndex) {
      var i = fromIndex | 0,
          len = this.length;

      for (; i < len; i++) {
        if (this[i] === valueToFind) {
          return true;
        }
      }

      return false;
    }
  });
}
//# sourceMappingURL=includes.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/polyfills/array/includes.js
// module id = 1836
// module chunks = 0